import { usePageContext } from "vike-react/usePageContext"
import { useState, useEffect } from "react"
import Button from "aldoo-ra/Button"

function Navbar() {
  const pageContext = usePageContext()
  const currentPath = pageContext?.currentPath || pageContext?.urlPathname || (typeof window !== 'undefined' ? window.location.pathname : '/')
  const [isScrolled, setIsScrolled] = useState(false)

  const shouldHide = currentPath?.startsWith('/admin') ||
                    (typeof window !== 'undefined' && window.location.pathname.startsWith('/admin'))

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  if (shouldHide) return null

  // Local navigation data
  const navigationItems = [
    { label: "Home", href: "/" },
    { label: "About", href: "/about" },
    { label: "Features", href: "/features" },
    { label: "Contacts", href: "/contacts" }
  ]

  return (
    <header
      className={`fixed top-0 left-0 right-0 w-full bg-paper border-b border-border z-50 transition-shadow duration-300 ${
        isScrolled ? 'shadow-md' : ''
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="h-16 flex items-center justify-between">
          {/* Logo */}
          <div className="w-[140px] flex-shrink-0 cursor-pointer">
            <div className="flex flex-row items-center gap-2 py-0 my-0">
              <div className="text-text font-bold text-xl">Your Logo</div>
            </div>
          </div>

          {/* Navigation Menu */}
          <nav className="hidden md:flex items-center gap-8">
            {navigationItems.map((item, index) => (
              <a
                key={index}
                href={item.href}
                className="text-text hover:text-primary transition-colors font-medium"
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="flex items-center gap-4">
            <Button
              variant="admin_primary"
              onClick={() => {
                if (typeof window !== 'undefined') {
                  window.location.href = '/get-started'
                }
              }}
            >
              Get Started
            </Button>
          </div>
        </div>
      </div>
    </header>
  )
}

// AldooComponent definition for auto-discovery
export const AldooComponent = {
  id: "Navbar",
  component: Navbar,
  description: "Main navigation bar with logo, menu items, and CTA button. Auto-hides on admin routes.",
  input: {},
}

export default Navbar
